<script setup lang="ts">
/**
 * Подвал публичных страниц.
 *
 * Реквизиты берутся с сервера, а не набраны здесь: лицо, которое принимает
 * деньги, обязано называться одинаково в подвале, в счёте и в оферте. Набранные
 * руками, они разойдутся с документами на первой же правке.
 */
import { RouterLink } from 'vue-router';
import { legal } from '../../site/public-data.js';
</script>

<template>
  <footer class="lp-wrap lp-footer">
    <span class="lp-brand__mark lp-brand__mark--sm">K</span>
    <span class="lp-footer__legal">
      {{ legal?.company.name || legal?.company.fullName || 'Keypi' }}
      <template v-if="legal?.company.inn"> · ИНН {{ legal.company.inn }}</template>
    </span>
    <div class="lp-spacer" />
    <!--
      Каталог в подвале, а не только в шапке отдельных страниц: он должен быть
      доступен с любой публичной страницы — и человеку, и поиску, который иначе
      считает его страницей-сиротой.
    -->
    <RouterLink to="/templates" class="lp-footer__link">Шаблоны</RouterLink>
    <RouterLink to="/offer" class="lp-footer__link">Публичная оферта</RouterLink>
    <RouterLink to="/payment-rules" class="lp-footer__link">Приём платежей</RouterLink>
    <RouterLink to="/privacy" class="lp-footer__link">Персональные данные</RouterLink>
    <a v-if="legal?.company.email" :href="`mailto:${legal.company.email}`" class="lp-footer__link">
      {{ legal.company.email }}
    </a>
  </footer>
</template>
